import { z } from 'zod';
import { requiredString } from '@/shared/lib/validation';

/** Проверяет данные назначения исполнителя на заказ */
export const createAssignExecutorSchema = (requiresAddress: boolean) => z.object({
    executorId: requiredString('Выберите исполнителя', { trim: false }),
    executorAddressId: z.string()
        .nullable(),
    comment: z.string()
        .trim(),
})
    .superRefine((values, context) => {
        if (requiresAddress && values.executorId && !values.executorAddressId) {
            context.addIssue({
                code: 'custom',
                path: ['executorAddressId'],
                message: 'Выберите адрес исполнителя',
            });
        }
    });

export type AssignExecutorFormValues = z.infer<ReturnType<typeof createAssignExecutorSchema>>;

export const ASSIGN_EXECUTOR_FORM_DEFAULTS: AssignExecutorFormValues = {
    executorId: '',
    executorAddressId: null,
    comment: '',
};
